import { render, staticRenderFns } from "./headBox.vue?vue&type=template&id=1a6a6fbe&scoped=true&"
import script from "./headBox.vue?vue&type=script&lang=js&"
export * from "./headBox.vue?vue&type=script&lang=js&"
import style0 from "./headBox.vue?vue&type=style&index=0&id=1a6a6fbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6a6fbe",
  null
  
)

export default component.exports